<ng-template [ngIf]="isComunicandoEsitoSopralluogo">
  <app-loading></app-loading>
</ng-template>
 <p-steps [model]="pagineComunicaEsitoSopralluogo" [readonly]="true" [activeIndex]="activeIndex" >  </p-steps> 
    <div class="d-flex mt-2">
    <ng-container [ngSwitch]="activeIndex">
        <ng-container *ngSwitchCase="0">
            <form [formGroup]="comunicaEsitoSopralluogoForm">
              <div class="grid formgrid p-fluid">
                <div class="field mt-2 mb-2 col-8">
                 
                  <label for="dataEsecuzione" class="font-small text-900 text-blue-900">Data esecuzione</label>
                  <span class="p-input-icon-left">
                    <p-calendar
                      formControlName="dataEsecuzione"
                      id="dataEsecuzione"
                      [showIcon]="true"
                      dateFormat="dd/mm/yy"
                      placeholder="Data del sopralluogo"
                      [appendTo]="'body'"
                    ></p-calendar>
        
                  </span>
              </div>
              <div class="field mt-2 mb-2 col-4">
                 <label for="esito" class="font-small text-900 text-blue-900">Esito</label>
                  <span class="p-input-icon-left">
                    <p-selectButton [options]="esiti" formControlName="esito" optionLabel="label" optionValue="value" (onChange)="onEsitoChange($event.value)"></p-selectButton>
                  </span>
              </div>
              <div class="field mt-2 mb-2 " [ngClass]="{'col-12': esitoOK , 'col-8': !esitoOK}">
                <label for="esito" class="font-small text-900 text-blue-900">Note</label>
                <span class="p-input-icon-left">
                  <i class="pi pi-info-circle"></i>
                  <textarea id="note" rows="5" [autoResize]="true" formControlName="noteSopralluogo" pInputTextarea></textarea>
                </span>
              </div>
              <div *ngIf="!esitoOK" class="field mt-2 mb-2 col-4">
                <label for="causaKO" class="font-small text-900 text-blue-900">Causa KO</label>
                <p-dropdown inputId="causaKO" 
                [options]="listeService.opzioniCausaKO" 
                [showClear]="true"
                      placeholder="Indica la causa del KO" formControlName="causaKO">
                      <ng-template let-causa pTemplate="item">
                          <div class="flex align-items-center">
                              <p-tag
                              [value]="causa.label | uppercase"
                              [style]="{
                              'background-color': stiliService.getColoreCategoriaVincoloKO(getPrimoCarattereNumerico(causa.value)) ,
                              'color': '#ffffff' ,
                              'border-radius': '6px',
                              'padding': '.25em .25rem',
                              'font-weight': '700',
                              'font-size': '11px',
                              'letter-spacing': '.3px;',
                              'cursor': 'pointer',
                              }"
                              class="mr-1">
                          </p-tag>
                          </div>
                      </ng-template>
                  </p-dropdown>
                <!--  <span class="p-input-icon-left">
                   <p-selectButton [options]="causeKO" formControlName="causaKO" optionLabel="label" optionValue="value"></p-selectButton>
                 </span> -->
             </div>
            </div>
          </form> 
          </ng-container>
          <ng-container *ngSwitchCase="1">
            <form [formGroup]="lavoriExtraForm">
              <div class="grid formgrid p-fluid">
                <div class="field mt-2 mb-2 col-4">
                  <label for="lavoriNecessari" class="font-small text-900 text-blue-900">Sono necessari lavori extra?</label>
                   <span class="p-input-icon-left">
                     <p-selectButton [options]="lavoriExtra" formControlName="lavoriNecessari" optionLabel="label" optionValue="value"></p-selectButton>
                  </span>
               </div>
               <div *ngIf="lavoriNecessari" class="field mt-2 mb-2 col-4">
                  <label for="preventivo" class="font-small text-900 text-blue-900">Si conosce l'entità dei lavori extra?</label>
                  <span class="p-input-icon-left">
                    <i class="pi pi-euro"></i>
                    <p-inputNumber mode="currency" inputId="preventivo" currency="EUR" locale="it-IT" formControlName="preventivo" [styleClass]="'right-align'"> </p-inputNumber>
                  </span>
                </div>
                <div *ngIf="lavoriNecessari" class="field mt-2 mb-2 col-4">
                  <label for="preventivo" class="font-small text-900 text-blue-900 mb-2">Siete già in possesso del file di preventivo?</label>
                  <span class="p-input-icon-left">
                    <i class="pi pi-upload "></i>
                    <p-fileUpload 
                          mode="basic" 
                          name="caricaFilePreventivo"
                          multiple="false"
                          maxFileSize="5000000000"
                          accept=".pdf"
                          [auto]="false"
                          chooseLabel="{{label}}"
                          chooseIcon="{{icona}}"
                          uploadIcon="{{icona}}"
                          uploadLabel="{{label}}"
                          [styleClass]="filePreventivoClass"
                          (onUpload)="onPreventivoFileUpload($event)" 
                          (onSelect)="onPreventivoFileSelect($event)" 
                          url="https://www.primefaces.org/cdn/api/upload.php"
                      >
                </p-fileUpload>
                  </span>
                </div>
               <div *ngIf="lavoriNecessari" class="field mt-2 mb-2 col-12">
                  <label for="noteLavoriExtra" class="font-small text-900 text-blue-900">Note</label>
                  <span class="p-input-icon-left">
                    <i class="pi pi-info-circle"></i>
                    <textarea id="noteLavoriExtra" rows="5" [autoResize]="true" formControlName="noteLavoriExtra" pInputTextarea></textarea>
                </span>
              </div>
              </div>
            </form>
          </ng-container>
          <ng-container *ngSwitchCase="2">
            <form [formGroup]="permessoForm">
              <div class="grid formgrid p-fluid">
                  <div class="field mt-2 mb-2 col-8">
                    <label for="permessoNecessario" class="font-small text-900 text-blue-900">E' necessario richiedere dei permessi ad un ente pubblico?</label>
                     <span class="p-input-icon-left">
                       <p-selectButton [options]="lavoriExtra" formControlName="permessoNecessario" optionLabel="label" optionValue="value"></p-selectButton>
                    </span>
                 </div>
                 <div *ngIf="permessoNecessario" class="field mt-2 mb-2 col-12">
                  <label for="permessoNecessario" class="font-small text-900 text-blue-900">Note</label>
                  <span class="p-input-icon-left">
                    <i class="pi pi-info-circle"></i>
                    <textarea id="notePermesso" rows="5" [autoResize]="true" formControlName="notePermesso" pInputTextarea></textarea>
                </span>
              </div>
              </div>
            </form>
          </ng-container>
         </ng-container>
    </div>

  
    <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

    <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
      
      <p-button icon="pi pi-arrow-left" class="p-button-text mr-2" (click)="activeIndex = activeIndex - 1" [disabled]="activeIndex === 0 "></p-button>
       <p-button icon="pi pi-arrow-right" class="p-button-text mr-1" (click)="changePage()" [disabled]="checkNextStep()"></p-button>
       <p-button *ngIf="activeIndex !== pagineComunicaEsitoSopralluogo.length -1" icon="pi pi-check" label="{{labelConferma}}"
        class="p-button-text ml-100" styleClass="p-button-success" severity="{{severityConferma}}" (click)="conferma(true)" 
        [disabled]="isComunicandoEsitoSopralluogo || !comunicaEsitoSopralluogoForm.valid "></p-button>
       <p-button *ngIf="activeIndex === pagineComunicaEsitoSopralluogo.length -1" icon="pi pi-check" label="Conferma"
        class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isComunicandoEsitoSopralluogo"></p-button>
    </div>
    <p-toast />
    <p-confirmDialog /> 